import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { RetailerNetworkLocationFilter } from '@occc/graphql';

import { useGetRetailerNetworkLocations } from '../../../data-access/queries';
import {
  ConnectionStatus,
  toConnectionStatusEquals,
} from '../retailer-network-my-stores-v2-page.types';

type UseStoresFlatLocationsOptions = {
  networkId: string;
  stateFilter: string;
  cityFilter: string;
  connectionStatusFilter: ConnectionStatus | '';
  search: string;
};

const FLAT_LIST_PAGE_SIZE = 8;

// Used whenever any filter (State/City/Connection Status) or Search is active — the page
// switches to a flat, paginated list of matching locations (no group headers). See
// `hasActiveFilterOrSearch` in retailer-network-my-stores-v2-page.utils.ts.
export const useStoresFlatLocations = ({
  networkId,
  stateFilter,
  cityFilter,
  connectionStatusFilter,
  search,
}: UseStoresFlatLocationsOptions) => {
  const [paginationInfo, onPageChange] = usePaginationParams({ pageSize: FLAT_LIST_PAGE_SIZE });

  const filter: RetailerNetworkLocationFilter = {
    retailerNetworkUuidEquals: networkId,
    stateEquals: stateFilter || undefined,
    cityEquals: cityFilter || undefined,
    connectionStatusEquals: toConnectionStatusEquals(connectionStatusFilter),
    search: search.trim() || undefined,
  };

  const {
    data: locations = [],
    loading,
    paginationProps,
  } = useGetRetailerNetworkLocations({
    filter,
    pageSize: FLAT_LIST_PAGE_SIZE,
    paginationInfo,
    onPageChange,
  });

  return { locations, loading, paginationProps };
};
